import CategorySettings from "./CategorySettings";
import CustomerGroupPrintSets from "./CustomerGroupPrintSets";

/** The policy values of GET /system-settings, one ตั้งค่าระบบ tab per category. */
export const POLICY_SETTINGS_TABS = [
  { label: "รายงาน", component: <CategorySettings category="report" /> },
  { label: "สมุดราคา", component: <CategorySettings category="pricebook" /> },
  {
    label: "ลูกค้า",
    component: (
      <CategorySettings category="customer">
        <CustomerGroupPrintSets />
      </CategorySettings>
    ),
  },
  { label: "การเข้าเยี่ยมร้าน", component: <CategorySettings category="visit" /> },
  { label: "e-Tax", component: <CategorySettings category="etax" /> },
  { label: "QR", component: <CategorySettings category="qr" /> },
  { label: "พิมพ์ซ้ำ", component: <CategorySettings category="reprint" /> },
  { label: "ใบสั่งซื้อ PO", component: <CategorySettings category="purchase_order" /> },
  { label: "BDC", component: <CategorySettings category="bdc" /> },
];
